export var AfriexCountryCode;
(function (AfriexCountryCode) {
    AfriexCountryCode["NG"] = "NG";
    AfriexCountryCode["GB"] = "GB";
    AfriexCountryCode["GI"] = "GI";
    AfriexCountryCode["US"] = "US";
    AfriexCountryCode["CA"] = "CA";
    AfriexCountryCode["KE"] = "KE";
    AfriexCountryCode["GH"] = "GH";
    AfriexCountryCode["UG"] = "UG";
    AfriexCountryCode["CM"] = "CM";
    AfriexCountryCode["ET"] = "ET";
    AfriexCountryCode["HT"] = "HT";
    AfriexCountryCode["AT"] = "AT";
    AfriexCountryCode["BE"] = "BE";
    AfriexCountryCode["HR"] = "HR";
    AfriexCountryCode["CY"] = "CY";
    AfriexCountryCode["EE"] = "EE";
    AfriexCountryCode["FI"] = "FI";
    AfriexCountryCode["FR"] = "FR";
    AfriexCountryCode["DE"] = "DE";
    AfriexCountryCode["GR"] = "GR";
    AfriexCountryCode["IE"] = "IE";
    AfriexCountryCode["IT"] = "IT";
    AfriexCountryCode["LV"] = "LV";
    AfriexCountryCode["LI"] = "LI";
    AfriexCountryCode["LT"] = "LT";
    AfriexCountryCode["LU"] = "LU";
    AfriexCountryCode["MT"] = "MT";
    AfriexCountryCode["NL"] = "NL";
    AfriexCountryCode["PT"] = "PT";
    AfriexCountryCode["SK"] = "SK";
    AfriexCountryCode["SI"] = "SI";
    AfriexCountryCode["ES"] = "ES";
    AfriexCountryCode["RO"] = "RO";
    AfriexCountryCode["NO"] = "NO";
    AfriexCountryCode["UA"] = "UA";
    AfriexCountryCode["AU"] = "AU";
    AfriexCountryCode["RU"] = "RU";
    AfriexCountryCode["BF"] = "BF";
    AfriexCountryCode["ML"] = "ML";
    AfriexCountryCode["SN"] = "SN";
    AfriexCountryCode["TG"] = "TG";
    AfriexCountryCode["GN"] = "GN";
    AfriexCountryCode["BJ"] = "BJ";
    AfriexCountryCode["CI"] = "CI";
    AfriexCountryCode["EG"] = "EG";
    AfriexCountryCode["MX"] = "MX";
    AfriexCountryCode["CN"] = "CN";
    AfriexCountryCode["IN"] = "IN";
    AfriexCountryCode["PH"] = "PH";
    AfriexCountryCode["BR"] = "BR";
    AfriexCountryCode["UY"] = "UY";
    AfriexCountryCode["PK"] = "PK";
    AfriexCountryCode["BG"] = "BG";
    AfriexCountryCode["CZ"] = "CZ";
    AfriexCountryCode["DK"] = "DK";
    AfriexCountryCode["HU"] = "HU";
    AfriexCountryCode["PL"] = "PL";
    AfriexCountryCode["SE"] = "SE";
    AfriexCountryCode["RW"] = "RW";
    AfriexCountryCode["ZA"] = "ZA";
    AfriexCountryCode["EU"] = "EU";
    AfriexCountryCode["CG"] = "CG";
    AfriexCountryCode["TZ"] = "TZ";
    AfriexCountryCode["ZM"] = "ZM";
    AfriexCountryCode["MG"] = "MG";
    AfriexCountryCode["MW"] = "MW";
    AfriexCountryCode["MZ"] = "MZ";
    AfriexCountryCode["SS"] = "SS";
    AfriexCountryCode["BW"] = "BW";
    AfriexCountryCode["GA"] = "GA";
    AfriexCountryCode["CF"] = "CF";
    AfriexCountryCode["GM"] = "GM";
    AfriexCountryCode["NE"] = "NE";
    AfriexCountryCode["CD"] = "CD";
    AfriexCountryCode["GW"] = "GW";
    AfriexCountryCode["MA"] = "MA";
    AfriexCountryCode["SL"] = "SL";
    // Liberia and Djibouti, added for PAPSS's four-corridor UAT batch
    // (2026-08-26): LR/LRD and DJ/DJF, alongside the already-registered
    // KE/KES and SL/SLE.
    AfriexCountryCode["LR"] = "LR";
    AfriexCountryCode["DJ"] = "DJ";
    AfriexCountryCode["HK"] = "HK";
    AfriexCountryCode["CH"] = "CH";
    AfriexCountryCode["AE"] = "AE";
    AfriexCountryCode["SA"] = "SA";
    AfriexCountryCode["QA"] = "QA";
    AfriexCountryCode["KW"] = "KW";
    AfriexCountryCode["SG"] = "SG";
    AfriexCountryCode["NZ"] = "NZ";
    AfriexCountryCode["JP"] = "JP";
    AfriexCountryCode["KR"] = "KR";
    AfriexCountryCode["BD"] = "BD";
    AfriexCountryCode["ID"] = "ID";
    AfriexCountryCode["MY"] = "MY";
    AfriexCountryCode["TH"] = "TH";
    AfriexCountryCode["VN"] = "VN";
    AfriexCountryCode["TR"] = "TR";
    AfriexCountryCode["CO"] = "CO";
    AfriexCountryCode["PE"] = "PE";
    AfriexCountryCode["CL"] = "CL";
    AfriexCountryCode["AR"] = "AR";
    AfriexCountryCode["DZ"] = "DZ";
    AfriexCountryCode["TN"] = "TN";
    AfriexCountryCode["ZW"] = "ZW";
    AfriexCountryCode["NA"] = "NA";
    // Added to cover IBAN table entries in @afriex/core/iban's non-SEPA country
    // list (ibanCountryTable.ts) that had no corresponding enum member --
    // without these, assertIbanCountryIsPayable's supportedCountries.includes()
    // corridor check could never match an IBAN from one of these countries.
    AfriexCountryCode["AZ"] = "AZ";
    AfriexCountryCode["BA"] = "BA";
    AfriexCountryCode["BH"] = "BH";
    AfriexCountryCode["GE"] = "GE";
    AfriexCountryCode["IL"] = "IL";
    AfriexCountryCode["JO"] = "JO";
    AfriexCountryCode["KZ"] = "KZ";
    AfriexCountryCode["MU"] = "MU";
    AfriexCountryCode["KM"] = "KM";
    AfriexCountryCode["AD"] = "AD";
    AfriexCountryCode["AG"] = "AG";
    AfriexCountryCode["AM"] = "AM";
    AfriexCountryCode["AO"] = "AO";
    AfriexCountryCode["BB"] = "BB";
    AfriexCountryCode["BI"] = "BI";
    AfriexCountryCode["BN"] = "BN";
    AfriexCountryCode["BO"] = "BO";
    AfriexCountryCode["BS"] = "BS";
    AfriexCountryCode["BT"] = "BT";
    AfriexCountryCode["BZ"] = "BZ";
    AfriexCountryCode["CR"] = "CR";
    AfriexCountryCode["CV"] = "CV";
    AfriexCountryCode["DM"] = "DM";
    AfriexCountryCode["DO"] = "DO";
    AfriexCountryCode["EC"] = "EC";
    AfriexCountryCode["ER"] = "ER";
    AfriexCountryCode["FJ"] = "FJ";
    AfriexCountryCode["FM"] = "FM";
    AfriexCountryCode["GD"] = "GD";
    AfriexCountryCode["GQ"] = "GQ";
    AfriexCountryCode["GT"] = "GT";
    AfriexCountryCode["GY"] = "GY";
    AfriexCountryCode["HN"] = "HN";
    AfriexCountryCode["IS"] = "IS";
    AfriexCountryCode["JM"] = "JM";
    AfriexCountryCode["KG"] = "KG";
    AfriexCountryCode["KH"] = "KH";
    AfriexCountryCode["KI"] = "KI";
    AfriexCountryCode["KN"] = "KN";
    AfriexCountryCode["LA"] = "LA";
    AfriexCountryCode["LC"] = "LC";
    AfriexCountryCode["LK"] = "LK";
    AfriexCountryCode["LS"] = "LS";
    AfriexCountryCode["MC"] = "MC";
    AfriexCountryCode["MD"] = "MD";
    AfriexCountryCode["MH"] = "MH";
    AfriexCountryCode["MN"] = "MN";
    AfriexCountryCode["MR"] = "MR";
    AfriexCountryCode["MV"] = "MV";
    AfriexCountryCode["NP"] = "NP";
    AfriexCountryCode["NR"] = "NR";
    AfriexCountryCode["OM"] = "OM";
    AfriexCountryCode["PA"] = "PA";
    AfriexCountryCode["PG"] = "PG";
    AfriexCountryCode["PW"] = "PW";
    AfriexCountryCode["PY"] = "PY";
    AfriexCountryCode["SB"] = "SB";
    AfriexCountryCode["SC"] = "SC";
    AfriexCountryCode["SM"] = "SM";
    AfriexCountryCode["SR"] = "SR";
    AfriexCountryCode["ST"] = "ST";
    AfriexCountryCode["SV"] = "SV";
    AfriexCountryCode["SZ"] = "SZ";
    AfriexCountryCode["TD"] = "TD";
    AfriexCountryCode["TJ"] = "TJ";
    AfriexCountryCode["TL"] = "TL";
    AfriexCountryCode["TM"] = "TM";
    AfriexCountryCode["TO"] = "TO";
    AfriexCountryCode["TT"] = "TT";
    AfriexCountryCode["TV"] = "TV";
    AfriexCountryCode["UZ"] = "UZ";
    AfriexCountryCode["VC"] = "VC";
    AfriexCountryCode["VU"] = "VU";
    AfriexCountryCode["WS"] = "WS";
})(AfriexCountryCode || (AfriexCountryCode = {}));
//# sourceMappingURL=AfriexCountryCode.js.map